import { Popover } from "@pankod/refine-antd";
import { BaseRecord, useCreate } from "@pankod/refine-core";
import React, { useEffect, useState } from "react";
import { AiFillLike, AiOutlineLike } from "react-icons/ai";
import { Content } from "../LikeListContent/LikeListContent";
import "./Like.scss";
import axios from "axios";
import { useMyTask } from "components/Mytask/Context/MyTask.context";
import { FaCheckCircle, FaRegCheckCircle } from "react-icons/fa";
import { handleReaction } from "components/Mytask/utils";

interface LikeProps {
  resourceId: number;
  likes: BaseRecord[];
  CurrentUserId: string | null;
  setDataScreen?: any
  targetKey?: string
}

export const Like: React.FC<LikeProps> = ({
  resourceId,
  likes,
  CurrentUserId,
  setDataScreen,
  targetKey
}) => {
  const { mutate } = useCreate();
  const [likeAmount, setLikeAmount] = useState<number>(likes?.length || 0);
  const [isLiked, setIsLiked] = useState(() => {
    return likes?.some((like) => like?.userId === CurrentUserId);
  });
  const values = useMyTask();
  const currentTaskDetailId = values?.currentTaskDetailId;
  const setComments = values?.setComments;
  const comments = values?.comments;
  useEffect(() => {
    setIsLiked(() => {
      return likes?.some((like) => like.userId === CurrentUserId);
    });
    setLikeAmount(likes?.length);
  }, [likes]);

  const toggleLike = async () => {
    const nextIsLiked = !isLiked;
    setIsLiked(nextIsLiked);

    const currentLikes = [{
      resourcesId: resourceId,
      userId: CurrentUserId,
      createdAt: new Date(),
    }];

    mutate(
      {
        resource: 'resources/like',
        values: {
          resourcesId: resourceId,
        },
        successNotification: false,
        invalidates: ['all'],
      },
      {
        onSuccess: async (data, variables, context) => {
          handleReaction({
            type: 'like',
            toggle: nextIsLiked,
            data: currentLikes,
            setData: setDataScreen,
            targetKey
          });
          await new Promise((resolve) => setTimeout(resolve, 300));
          fetchComments();
        },
        onError: (error, variables, context) => {
          setIsLiked((prev) => !prev);
          console.error('Lỗi khi dislike:', error);
        },
      }
    );
  };

  const fetchComments = async () => {
    try {
      const res = await axios.get(
        `resourcesrelation/get-comment?filter=resourcesparentid%7C%7C%24eq%7C%7C${currentTaskDetailId}&filter=resources.resourcetype%7C%7C%24in%7C%7Ccomment,log&fields=resourcesid&join=resources%7C%7Cgid%2Cname%2Ccreatedby%2CcreatedAt%2CupdatedAt%2Cresourcetype%2ChasFile&join=resources.resourcesDetails%7C%7CpinTop&join=resources.resourcesLikes%7C%7CuserId&join=resources.resourcesDislikes%7C%7CuserId&limit=10&page=1&offset=0&sort=resources.createdAt%2CDESC`
      );
      const respon = res?.data?.data;
      const newData: any = comments?.map(itemA => {
        const matchedB = respon.find((itemB: any) =>itemB.resourcesid === itemA.resourcesid);
        return {
          ...itemA,
          resources: matchedB ? matchedB.resources : itemA.resources
        };
      });
      setComments && setComments(newData)
    } catch (error) {
      console.error('Lỗi khi gọi API get-comment:', error);
    }
  };

  const overlayStyle = { backgroundColor: 'var(--tool-tip-bg-color)' }

  return (
    <div className='wrapper-like'>
      <Popover overlayInnerStyle={overlayStyle} content={likeAmount > 0 ? <Content cmtId={resourceId} /> : null} placement="topRight" >
        {/* {!isLiked ? (<AiOutlineLike className="comment-icon" onClick={toggleLike} />) : (<AiFillLike className="comment-icon liked" onClick={toggleLike} />)} */}
        {!isLiked ? (
          <FaRegCheckCircle className="comment-icon" onClick={toggleLike} color='blue' />
        ) : (
          <FaCheckCircle className="comment-icon liked" onClick={toggleLike} />
        )}
      </Popover>
      <div className="like-amount">{likeAmount > 0 ? likeAmount : ""}</div>
    </div>
  );
};


